import React, { useState } from 'react';
import { Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import Portfolio from './pages/Portfolio.tsx';
import StrategyBuilder from './pages/StrategyBuilder.tsx';
import VaultBuilder from './pages/VaultBuilder.tsx';
import Marketplace from './pages/Marketplace.tsx';

const navItems = [
  { path: '/portfolio', label: 'Portfolio', icon: '💼' },
  { path: '/builder', label: 'Strategy Builder', icon: '🛠️' },
  { path: '/vault-builder', label: 'Vault Builder', icon: '🏗️' },
  { path: '/marketplace', label: 'Marketplace', icon: '🗄️' },
];

function Sidebar({ collapsed, setCollapsed }: { collapsed: boolean; setCollapsed: (v: boolean) => void }) {
  const location = useLocation();
  return (
    <div className={`h-screen bg-starkglass backdrop-blur-md shadow-glass flex flex-col transition-all duration-200 ${collapsed ? 'w-20' : 'w-56'} border-r border-accent/30`}>
      <div className="flex items-center justify-between px-4 py-4 border-b border-accent/20">
        <span className={`text-xl font-bold text-accent tracking-tight transition-all duration-200 ${collapsed ? 'text-lg' : ''}`}>{collapsed ? 'S' : 'StarkFi'}</span>
        <button
          className="text-gray-400 hover:text-accent focus:outline-none ml-2"
          onClick={() => setCollapsed(!collapsed)}
          aria-label="Toggle sidebar"
        >
          {collapsed ? <span>&#9654;</span> : <span>&#9664;</span>}
        </button>
      </div>
      <nav className="flex-1 mt-4">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center gap-3 px-4 py-3 my-1 rounded-lg transition-all duration-150
              ${location.pathname === item.path ? 'bg-gradient-to-r from-accent/20 to-accent2/10 text-accent shadow-accent' : 'hover:bg-starkpanel hover:text-accent3'}
              ${collapsed ? 'justify-center' : ''}
            `}
          >
            <span className="text-2xl w-7 text-center">{item.icon}</span>
            {!collapsed && <span className="text-base font-semibold">{item.label}</span>}
          </Link>
        ))}
      </nav>
      <div className="mb-4" />
    </div>
  );
}

function App() {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="flex min-h-screen bg-gradient-to-br from-starkbg via-[#181a20] to-[#23263a]">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <main className={`flex-1 transition-all duration-200 ${collapsed ? 'ml-20' : 'ml-56'} px-2 md:px-8 py-8`}>
        <Routes>
          <Route path="/" element={<Navigate to="/portfolio" replace />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/builder" element={<StrategyBuilder />} />
          <Route path="/vault-builder" element={<VaultBuilder />} />
          <Route path="/marketplace" element={<Marketplace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
